import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Image } from '../../../common/image'
import Map from '../../../common/Map'
import { formatText } from '../../../helpers/value'
import { COMPANY_INFO_KEYS } from './constants'
import iconLocation from './location.svg'

export const BlockLocation = ({ data, isDomesticSearch }) => {
  const { REGISTERED_ADDRESS } = COMPANY_INFO_KEYS
  const location = data[REGISTERED_ADDRESS]

  const getLocation = () => {
    if (!data) return false

    if (!isDomesticSearch) {
      return {
        text: Array.isArray(location) ? location[0] : '',
        address: Array.isArray(location) ? location[0] : '',
      }
    }

    return {
      text: formatText(location),
      address: location,
    }
  }

  return (
    <div>
      <div className="px1 py2">
        <div className="dFlex alignItemsCenter fw600 mb1">
          <Image src={iconLocation} alt="location" style={{ width: 20 }} />
          <span style={{ marginLeft: 12 }}>
            <Translate value="domesticSearchPreview.LOCATION" />
          </span>
        </div>
        <Element elementName="span" style={{ color: '#3A414B' }}>
          {getLocation() && getLocation().text}
        </Element>
      </div>
      {getLocation() && <Map address={getLocation().address} height={200} />}
    </div>
  )
}
